import React, { useEffect, useLayoutEffect, useRef, useCallback } from 'react'
import PropTypes from 'prop-types'
import Autocomplete from 'react-autocomplete'
import { connect } from 'react-redux'
// import _ from 'lodash'
import { debounce } from 'lodash'
import { useTranslation } from 'react-i18next'

import SearchSelect from '../../dump/menuComponents/SearchSelect'

// Used to debounce search functions.
// call .cancel() before invoking to cancel the previous invokations for
// desired behavior
// const debounce = _.debounce(func => func(), 1000)

const EventClipsSearchType = (props) => {
	const { devices, drivers, searchCategory, autoValue, onSearchCategoryChange, searchVehicle, setPropStates, webfleetDeviceId } = props
	const { t } = useTranslation('translation', { keyPrefix: 'eventsPage.eventClipsSearchType' });
	const prevAutoValue = useRef(props.autoValue)
	const prevSearchCategory = useRef(props.searchCategory)
	const autocompleteRef = useRef(null)
	const wrapperRef = useRef(null)
	const isFocusedRef = useRef(false)
	const userGestureAwayRef = useRef(false)

	// The search reload (triggered while typing) re-renders this component and can
	// drop DOM focus back to <body> (e.g. react-autocomplete rebuilding its input),
	// and a toastr notification popping up (e.g. "no events found") grabs focus for
	// a11y in a separate render pass that this component never sees. Track whether
	// the user is actively in the search field and reclaim focus whenever it's lost
	// for one of those reasons - but not if the user themselves deliberately moved
	// focus elsewhere (a real click or Tab/Escape press).
	useEffect(() => {
		// Fires before the resulting blur/focusin events, letting us tell "user
		// clicked/tabbed away" apart from a programmatic focus steal (which has
		// no preceding user gesture on another element).
		const handlePointerDown = (e) => {
			userGestureAwayRef.current = !wrapperRef.current?.contains(e.target)
		}
		const handleKeyDown = (e) => {
			if (e.key === 'Tab' || e.key === 'Escape') {
				userGestureAwayRef.current = true
			}
		}
		// Catches focus steals that happen outside this component's own render
		// (e.g. a toastr popup mounted elsewhere in the tree), which the
		// layout effect below can't see since this component doesn't re-render
		// when that happens.
		const handleFocusIn = (e) => {
			if (!isFocusedRef.current || wrapperRef.current?.contains(e.target)) {
				return
			}
			if (userGestureAwayRef.current) {
				isFocusedRef.current = false
				userGestureAwayRef.current = false
				return
			}
			autocompleteRef.current?.focus()
		}
		document.addEventListener('mousedown', handlePointerDown, true)
		document.addEventListener('keydown', handleKeyDown, true)
		document.addEventListener('focusin', handleFocusIn)
		return () => {
			document.removeEventListener('mousedown', handlePointerDown, true)
			document.removeEventListener('keydown', handleKeyDown, true)
			document.removeEventListener('focusin', handleFocusIn)
		}
	}, [])

	const handleSearchInputFocus = () => {
		isFocusedRef.current = true
	}
	const handleSearchInputBlur = () => {
		if (userGestureAwayRef.current) {
			isFocusedRef.current = false
			userGestureAwayRef.current = false
		}
		// Otherwise leave isFocusedRef as-is - the layout effect below (for a
		// same-render focus drop) and the focusin listener above (for a focus
		// steal from elsewhere in the tree) will restore it.
	}

	useLayoutEffect(() => {
		if (!isFocusedRef.current) {
			return
		}
		if ((searchCategory === 'vehicle' || searchCategory === 'driver') && document.activeElement?.id !== 'states-autocomplete') {
			autocompleteRef.current?.focus()
		}
	})

	const SEARCH_OPTIONS = {
		0: [
			{ value: 'vehicle', name: t('Vehicle') },
			{ value: 'driver', name: t('Driver') },
			{ value: 'event', name: t('Event') },
		],
		1: [
			{ value: 'driver', name: t('Driver') },
			{ value: 'event', name: t('Event') },
		],
	}

	// const debouncedChangeHandler = debounce(func => func(), 1000)
	// const debouncedChangeHandler = useMemo(
	// 	debounce(() => searchVehicle(), 1000)
	//   , []);
	// const debouncedChangeHandler = useCallback(
	// 	() => debounce(searchVehicle, 1000),
	// 	[]
	// );
	const debouncedChangeHandler = (debounce(searchVehicle, 1000)) //, [props.autoValue])

	// useEffect(() => {
	// 	if (prevAutoValue.current !== props.autoValue) {
	// 		searchVehicle()
	// 		prevAutoValue.current = props.autoValue
	// 	}
	// }, [props.autoValue])
	useEffect(() => {
		// debugger
		if (prevAutoValue.current !== props.autoValue) {
			// debugger
			// searchVehicle()
			debouncedChangeHandler(props.autoValue)
			prevAutoValue.current = props.autoValue
		}
	}, [props.autoValue])

	// Stop the invocation of the debounced function after unmounting
	useEffect(() => {
		return () => {
			debouncedChangeHandler.cancel();
		}
	}, [/*props.autoValue,*/ debouncedChangeHandler]);

	useEffect(() => {
		// debugger
		if (prevSearchCategory.current !== props.searchCategory) {
			// debugger
			onSearchCategoryChange()
			// searchVehicle()
			prevSearchCategory.current = props.searchCategory
		}

	}, [props.searchCategory])

	const menuStyle = {
		borderRadius: '3px',
		boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
		background: 'rgba(255, 255, 255, 0.9)',
		padding: '2px 0',
		fontSize: '90%',
		position: 'absolute',
		overflow: 'auto',
		maxHeight: '200px',
		left: '0',
		top: 'auto',
	}

	const matchStateToTerm = (item, value) => {
		if (item.vehicle_name) {
			return item.vehicle_name.toLowerCase().indexOf(value.toLowerCase()) !== -1;
		}

		return item.device_id.toString().toLowerCase().indexOf(value.toLowerCase()) !== -1;
	}

	const displayItemName = (item) => {
		return item.vehicle_name || item.device_id
	}

	const matchStateToTermDriver = (item, value) => {
		if (item.name) {
			return item.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
		}

		return item.id.toLowerCase().indexOf(value.toLowerCase()) !== -1
	}

	const displayItemNameDriver = (item) => {
		return item.name || item.id
	}

	return (
		<SearchSelect
			placeholder={t('placeholderSelect')}
			value={searchCategory}
			// onChangeCb={onSearchCategoryChange}
			onChangeCb={(e) => setPropStates({ searchCategory: e.target.value })}
			optionsList={SEARCH_OPTIONS[(webfleetDeviceId.length > 0) * 1]}
		>
			{searchCategory === 'vehicle' && (
				<Autocomplete
					ref={autocompleteRef}
					autoHighlight
					value={autoValue}
					inputProps={{ id: 'states-autocomplete', onFocus: handleSearchInputFocus, onBlur: handleSearchInputBlur }}
					wrapperProps={{ className: 'search-autocomplete event-search-input md-width', ref: wrapperRef }}
					getItemValue={item => item.vehicle_name || item.device_id}
					shouldItemRender={matchStateToTerm}
					onChange={(e, value) => {
						// debounce.cancel()
						// debouncedChangeHandler.cancel()
						// setPropStates({ autoValue: value }, () => debounce(searchVehicle))
						setPropStates({ autoValue: value })
						// debouncedChangeHandler(value)
					}}
					onSelect={(value, item) => {
						// setPropStates({ autoValue: value }, () => searchVehicle())
						setPropStates({ autoValue: value })
					}}
					renderMenu={(items, value, style) => {
						return <div className="items-list" style={{ ...style, ...menuStyle }} children={items} />
					}}
					renderItem={(item, isHighlighted) => (
						<div
							className={`item ${isHighlighted ? 'item-highlighted' : ''}`}
							key={item.device_id}
						>
							{displayItemName(item)}
						</div>
					)}
					renderInput={ownProps => <input {...ownProps} placeholder={t('placeholderSearchVehicle')} className="form-control event-page-search" />}
					items={devices}
				/>
			)}

			{searchCategory === 'driver' && (
				<Autocomplete
					ref={autocompleteRef}
					autoHighlight
					value={autoValue}
					inputProps={{ id: 'states-autocomplete', onFocus: handleSearchInputFocus, onBlur: handleSearchInputBlur }}
					wrapperProps={{ className: 'search-autocomplete event-search-input md-width', ref: wrapperRef }}
					getItemValue={item => item.name || item.id}
					shouldItemRender={matchStateToTermDriver}
					onChange={(e, value) => {
						// debounce.cancel()
						// setPropStates({ autoValue: value }, () => debounce(searchVehicle))
						setPropStates({ autoValue: value })
					}}
					onSelect={(value, item) => {
						// setPropStates({ autoValue: value }, () => searchVehicle())
						setPropStates({ autoValue: value })
					}}
					renderMenu={(items, value, style) => {
						return <div className="items-list" style={{ ...style, ...menuStyle }} children={items} />
					}}
					renderItem={(item, isHighlighted) => (
						<div
							className={`item ${isHighlighted ? 'item-highlighted' : ''}`}
							key={item.id}
						>
							{displayItemNameDriver(item)}
						</div>
					)}
					renderInput={ownProps => <input {...ownProps} placeholder={t('placeholderSearchDriver')} className="form-control event-page-search" />}
					items={drivers}
				/>
			)}

			{searchCategory === 'event' && (
				<input
					type="text"
					placeholder={t('placeholderSearchEvent')}
					id="event-search-input"
					className="form-control event-page-search event-search-input md-width"
					value={autoValue}
					onChange={(e) => {
						// debounce.cancel();
						// setPropStates({ autoValue: e.target.value }, () => debounce(searchVehicle))
						setPropStates({ autoValue: e.target.value })
					}}
				/>
			)}
		</SearchSelect>
	)
}

EventClipsSearchType.propTypes = {
	devices: PropTypes.arrayOf(PropTypes.object).isRequired,
	drivers: PropTypes.arrayOf(PropTypes.object).isRequired,
	searchCategory: PropTypes.string.isRequired,
	autoValue: PropTypes.string.isRequired,
	onSearchCategoryChange: PropTypes.func.isRequired,
	searchVehicle: PropTypes.func.isRequired,
	setPropStates: PropTypes.func.isRequired,
	webfleetDeviceId: PropTypes.string,
}

EventClipsSearchType.defaultProps = {
	webfleetDeviceId: '',
}

export default EventClipsSearchType;
